import React from "react";
import { useDispatch, useSelector } from "react-redux";
import orderAction from "../stores/actions/OrderAction";
import { toast } from "react-toastify";
import { RootState } from "../stores";

function OrderStatusUpdate({ orderId, status }: any) {
  const { profileDetails } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<any>();
  const handleChange = async (e: any) => {
    const val = e.target.value;
    if (
      window.confirm(`Order ${status} by ${profileDetails.name_of_entity} ?`)
    ) {
      try {
        await dispatch(
          orderAction.updateOrder({
            id: orderId,
            status: val,
          })
        );
        toast.success("Order Status Updated Successfully");
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <select className={"form-control form-control-sm"} onChange={handleChange}>
      <option value="" selected disabled>
        Select Delivery Status
      </option>
      <option value="PLACED" selected={status === "PLACED"}>
        PLACED
      </option>
      <option value="DISPATCH" selected={status === "DISPATCH"}>
        DISPATCH
      </option>
    </select>
  );
}

export default OrderStatusUpdate;
